import { useState, useEffect } from 'react';
import { getRailYear } from '../api/apiCall';

export type RailWeek = {
    weekNumber: number;
    startDate: Date;
    endDate: Date;
};

export const useRailCalendar = (token: string | undefined, year: string | number) => {
    const [railCalendarStart, setRailCalendarStart] = useState<Date | null>(null);
    const [weeks, setWeeks] = useState<RailWeek[]>([]);
    const [loading, setLoading] = useState<boolean>(true);

    useEffect(() => {
        if (!token || !year) return;

        const fetchRailCalendar = async () => {
            setLoading(true);
            try {
                const response = await getRailYear(token, year);
                if (response?.railYearStart) {
                    const startDate = new Date(response.railYearStart);
                    setRailCalendarStart(startDate);

                    // Generate all weeks for the rail year
                    const allWeeks: RailWeek[] = [];
                    for (let w = 1; w <= response.weeks; w++) {
                        const weekStart = new Date(startDate);
                        weekStart.setDate(startDate.getDate() + (w - 1) * 7);
                        const weekEnd = new Date(weekStart);
                        weekEnd.setDate(weekStart.getDate() + 6);
                        allWeeks.push({ weekNumber: w, startDate: weekStart, endDate: weekEnd });
                    }
                    setWeeks(allWeeks);
                } else {
                    setWeeks([]);
                    setRailCalendarStart(null);
                }
            } catch (error) {
                console.error('Error fetching rail calendar:', error);
                setWeeks([]);
                setRailCalendarStart(null);
            } finally {
                setLoading(false);
            }
        };
        

        fetchRailCalendar();
    }, [token, year]);

    return { railCalendarStart, weeks, loading };
};
